import React, { useState, useEffect } from "react";
import { Sidebar } from "primereact/sidebar";
import { getOnlyDateMMDDYY } from "../../../utils/helpers";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { CSVLink } from "react-csv";
import VoluntarySurveyService from "../../../services/voluntary-surveys/voluntarysurvey.services";
import { SelectedSiteReducer as VSurveySelectedSiteReducer, SurveyInfoReducer, SurveySummaryReducer } from "../../../store/voluntary-survey/site-operations/survey-details.store";

import { AppDispatch, AppState } from "../../../store/store";
import { useDispatch, useSelector } from "react-redux";
import { dataTablePaginatorTemplateSidebar } from "../../common/dataTablePaginatorTemplates";
import "../../inspection-overview/site-operations/survey-details/css/surveysidebar.css";

interface SurveyHistorySidebarProps {
  visible: boolean;
  onHide: () => void;
  selectedHeaderInfo: any;
  vSurveyHistoryData: any[];
}

const VSurveyHistory: React.FC<SurveyHistorySidebarProps> = (props: any) => {
  const { visible, onHide,vSurveyHistoryData }: any = props;
  const [searchValue, setSearchValue] = useState("");
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [selectedButtons, setSelectedButtons] = useState<{[key: string]: boolean}>({});
  const [routeUrl, setRouteUrl] = useState("");
  const dispatch: AppDispatch = useDispatch();
  const SelectedSiteInfo_Redux = useSelector((state: AppState) => state.VoluntarySurveySiteDetails.selectedSiteInfo);

  const handleClick = (buttonKey: string) => {
    setSelectedButtons((prevSelectedButtons) => ({
      ...prevSelectedButtons,
      [buttonKey]: !prevSelectedButtons[buttonKey],
    }));
  };

  // useEffect(() => {
  //   setFilteredData(
  //       vSurveyHistoryData.filter((data:any) =>
  //       data.cameraOperator.toLowerCase().includes(searchValue.toLowerCase())
  //     )
  //   );
  // }, [searchValue, vSurveyHistoryData]);

  const handleCSVDownload = () => {
    const csvData = [
      [
        "Survey Date",
        "Leaks Detected",
        "Camera Operator",
        "Camera Type",
        "Survey Duration",
      ],
      ...vSurveyHistoryData?.map((item:any) => [
        item.surveyDate?getOnlyDateMMDDYY(item.surveyDate): "NA",
        (item.surveyDate !== "" && item.surveyDate != null)?(`${item.totalLeaks} ${"leaks detected"}`):"Not Surveyed",
        item.cameraOperator?item.cameraOperator:"NA",
        item.cameraType?item.cameraType:"NA",
        item.surveyDuration?item.surveyDuration:"NA",
      ]),
    ];

    return csvData;
  };
  const csvFilename = `Voluntary_Survey_History_${Date.now()}`;

  const handleJsonDownLoad = async (cameraSiteId: any, surveyDate: any) => {
    try {
      const response = await VoluntarySurveyService.downloadVoluntarySurveyDetails(cameraSiteId, surveyDate);
      const json = JSON.stringify(response);
      const blob = new Blob([json], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `voluntary-data-${cameraSiteId}-${surveyDate}.json`
      );
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
    } catch (error) {
      console.error("Error downloading JSON:", error);
    }
  };
  
  const handleDateClick = async (cameraSiteId: any="", surveyDate: any="",siteName:any ="") => {
    // SiteName will be always empty for Survey history
    setRouteUrl(`/voluntary-details`);
    VoluntarySurveyService.getVSurveyInformation(
      cameraSiteId,
      getOnlyDateMMDDYY(surveyDate),
      siteName
    ).then((res: any) => {
      dispatch(SurveyInfoReducer(res as any));
      dispatch(VSurveySelectedSiteReducer({...SelectedSiteInfo_Redux,lastSurveyDate:surveyDate} as any));
    });
    VoluntarySurveyService.getVSurveyOverviewSummary(
      cameraSiteId,
      getOnlyDateMMDDYY(surveyDate),
      siteName
    ).then((res: any) => {
      dispatch(SurveySummaryReducer({ total: res.totalVideos, leaks: res.leaks, noleaks: res.noLeaks } as any));
    });
    onHide();
  }; 

  return (
    <Sidebar
      visible={visible}
      position="right"
      onHide={onHide}
      style={{ width: "60%", backgroundColor: "#272B34", color: "#FFFFFF" }}
      showCloseIcon={true}
    >
      <div>
      <header className="font-bold" style={{ fontSize: "18px" }}>{(vSurveyHistoryData && vSurveyHistoryData?.length <= 0)?`No Survey History for current Site`:`Select a survey`} </header>
        <hr />
        <div className="flex">
          <div>
            <div className="p-inputgroup flex-1 custom-inputgroup"></div>
          </div>
          <div className="ml-auto cursor-pointer">
            &nbsp;
          </div>
          <div className="pl-2">
            {(vSurveyHistoryData && vSurveyHistoryData?.length <= 0)?(<Button
              className={`circular-button ${selectedButtons["download"] ? "selected" : "" }`}
              style={{backgroundColor: selectedButtons["download"] ? "#FFB217" : "", cursor:"not-allowed"}}
              data-tooltip-id="tooltip-download"
            >
              <i className="pi pi-download" />
            </Button>):(<Button
              className={`circular-button ${selectedButtons["download"] ? "selected" : "" }`}
              onClick={() => handleClick("download")}
              style={{backgroundColor: selectedButtons["download"] ? "#FFB217" : "", cursor:"pointer"}}
              data-tooltip-id="tooltip-download"
            >
              <CSVLink data={handleCSVDownload()} filename={csvFilename}>
                <i className="pi pi-download" />
              </CSVLink>
            </Button>)}
            
          </div>
        </div>
        <DataTable
          value={vSurveyHistoryData}
          className="pt-4"
          paginator
          rows={11}
          paginatorTemplate={dataTablePaginatorTemplateSidebar}
        >
          <Column
            field="surveyDate"
            header="Survey Date"
            body={(rowData) => (
              <Button
                style={{
                  color: "#FFB217",
                  backgroundColor: "transparent",
                  border: "none",
                  padding: 0,
                  // cursor:"not-allowed"
                }}
                onClick={() => handleDateClick(rowData.cameraSiteId, rowData.surveyDate,"")}
              >
                {rowData.surveyDate?getOnlyDateMMDDYY(rowData.surveyDate): "NA"}
              </Button>
            )}
          />
          <Column
            field="leaksDetected"
            header="Leaks Detected"
            body={(rowData) => (
              <div
                className={
                  rowData.totalLeaks === 0
                    ? "green-background"
                    : "red-background"
                }
              >
                {`${rowData.totalLeaks} ${"leaks detected"}`}
              </div>
            )}
            style={{ width: "fit-content" }}
          />
          <Column 
            field="cameraOperator" 
            header="Camera Operator"
            body={(rowData) => <span>{rowData.cameraOperator?rowData.cameraOperator:"NA"}</span>} 
          />
          <Column 
            field="cameraType" 
            header="Camera Type"
            body={(rowData) => <span>{rowData.cameraType?rowData.cameraType:"NA"}</span>} 
          />
          <Column field="surveyDuration" header="Survey Duration"
            body={(rowData) => <span>{rowData.surveyDuration?rowData.surveyDuration:"NA"}</span>}  />
          <Column
            body={(rowData) => (
              <div>
                <Button
                  icon="pi pi-download"
                  onClick={() => handleJsonDownLoad(rowData.cameraSiteId, rowData.surveyDate)}
                  style={{
                    background: "none",
                    border: "none",
                    color: "#FFFFFF",
                    paddingLeft: "50px",
                    cursor: "pointer",
                  }}
                />
              </div>
            )}
          />
        </DataTable>
        <hr />
      </div>
    </Sidebar>
  );
};

export default VSurveyHistory;
